import { Component, OnInit } from '@angular/core';

import { UserProfileService, ProductRouteInfoService, ProductData } from '../core'

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss']
})
export class ReportsComponent implements OnInit {

  constructor(
        private userProfileService:UserProfileService

  ) { }

  ngOnInit() {
    let user = this.userProfileService.data;
    this.hasAccessToRateAudit = user.ProductAccess.includes("RateAudit");
    this.tabItems = [];
    if (this.hasAccessToRateAudit) {
        this.tabItems.push( {enabled: this.hasAccessToRateAudit, text: 'Rate Audit Summary', path:"rate-audit-summary-report"});
    }
    this.tabItems.push(   {enabled: true, text: 'GDS Usage', path:"gds-usage-report"});
    this.tabItems.push(   {enabled: true, text: 'Failed Email Notifications', path:"failed-email-notifications"});
  }
  hasAccessToRateAudit:boolean;

  tabItems:Array<{enabled:boolean, text:string, path:string}> =[];


}
